import * as React from 'react';
import { styled } from '@naan/stitches.config';
import { Button } from '@naan/primitives/button';
import { ClockIcon } from '@naan/icons/clock-icon';
// import { Story } from '@core/models/story-manager';
import { CheckmarkIcon } from '@naan/icons/checkmark-icon';
import { HSpacer } from '@naan/primitives/spacer';
import { observer } from 'mobx-react';
import { CenterColumnLayout } from 'components/layouts/center-column-layout';
import { notNil } from '@utils/conditionals';
import { AppFactory } from '@app/app-factory';
import { presentSimpleAlert } from 'components/ui/simple-dialogs';
import { useCurrentStory } from 'components/story-detail/current-story-context';
import { Story } from '@core/models/story-manager';
import { storyDetailUiModel } from 'components/story-detail/story-detail-ui-model';

import __ from '@core/lib/localization';

const Outer = styled('div', {
  position: 'sticky',
  zIndex: 1,

  // borderBottom: '1px solid $gray-100',
  backgroundColor: '$white',
  // bottom: 0,
  // top: 'calc( $$storyHeaderHeight +  $$tabbarHeight)',
  top: 'calc($$assignmentBannerHeight + $$storyHeaderHeight)',

  // top: '$$smallHeaderHeight',
  // '@medium': {
  //   top: '$$mediumHeaderHeight',
  // },
  variants: {
    inAssignment: {
      true: {
        // top: 'calc($$storyHeaderHeight + $$assignmentBannerHeight + tabbarHeight)',
        // top: 'calc($$assignmentBannerHeight + $$storyHeaderHeight +  $$tabbarHeight)',
        // '@medium': {
        //   top: 'calc($$mediumHeaderHeight + $$assignmentBannerHeight)',
        // },
      },
    },
  },
});

const StoryActionStyles = styled('div', {
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'flex-start',
  padding: '$space$4 0',
});

// type ButtonProps = React.ComponentProps<typeof Button>;

const StoryActionNotNull = observer(({ story }: { story: Story }) => {
  const { unstarted, unqueued, joinedClassroomAssignment: assignment } = story;

  const handleBeginStudying = React.useCallback(() => {
    const { offline } = AppFactory.root;
    if (offline && !story.isCachedMemoized) {
      presentSimpleAlert(
        <>
          {__(
            'You appear to be offline. Please try again later.',
            'offlineTryLater'
          )}
        </>
      );
    } else {
      story.progress.beginStudying();
      window.setTimeout(() => {
        storyDetailUiModel.executeAutoscroll();
      }, 200);
    }
  }, [story]);

  if (!unstarted) {
    return null;
  }

  // const ActionButton = (props: ButtonProps) => (
  //   <Responsive
  //     renderDefault={() => <Button css={{ flex: 1 }} {...props} />}
  //     renderMediumAndUp={() => <Button {...props} />}
  //   />
  // );

  return (
    <Outer inAssignment={notNil(assignment)}>
      <CenterColumnLayout narrow>
        <StoryActionStyles>
          <Button
            label={__('Begin story', 'beginStory')}
            presentation={'teal'}
            size="large"
            onClick={handleBeginStudying}
          />
          <HSpacer size={2} />
          <Button
            label={__('Later', 'later')}
            presentation={'secondary'}
            size="large"
            leftIcon={unqueued ? <ClockIcon /> : <CheckmarkIcon />}
            onClick={() => story.progress.toggleStudyLater()}
          />
        </StoryActionStyles>
      </CenterColumnLayout>
    </Outer>
  );
});

export const StoryAction = observer(() => {
  const story = useCurrentStory();

  if (story.locked) {
    return null;
  }

  return <StoryActionNotNull story={story} />;
});
